import {Calendar} from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import momentTimezonePlugin from '@fullcalendar/moment-timezone';
import moment from "moment-timezone"
import {DateFilterRule, FilterSource} from "../libs/filters/groupsListFilter";

export default context => {
    const container = $('#calendar', context);
    const translate = window.translate;
    if (container.length > 0) {
        // const format = new MessageFormat(document.documentElement.lang)
        // const ariaMessage = format.compile(translate.cal_day_button_label)
        const attachLabels = () => {
            container.find('.fc-header-toolbar .fc-prev-button[type="button"]').attr('aria-label', translate.cal_prev_button_label || '');
            container.find('.fc-header-toolbar .fc-next-button[type="button"]').attr('aria-label', translate.cal_next_button_label || '');
            container.find('.fc-day-today').attr('aria-label', translate.cal_current_button_label || '').attr('aria-current',true);
        };

        const calendarSource = new class extends FilterSource {
            from = 0
            to = 0
            constructor() {
                super()
                this.reset()
            }

            reset() {
                this.from = 0
                this.to = 0
            }

            getActiveRules() {
                if (this.enabled) {
                    return [
                        new DateFilterRule({
                            from: this.from,
                            to: this.to,
                        })
                    ]
                } else {
                    return []
                }
            }
        }

        const filter = $('#panel__regular-groups').data('filter')
        const calendar = new Calendar(container[0],
            {
                timeZone: window.community.timeZone,
                plugins: [momentTimezonePlugin, interactionPlugin, dayGridPlugin],
                selectable: true,
                initialView: 'dayGridMonth',
                headerToolbar: {
                    start: 'prev',
                    center: 'title',
                    end: 'next',
                },
                eventInteractive: true,
                eventDisplay: 'none',
                longPressDelay: 0,
                select: info => {
                    calendarSource.from = ~~(info.start.getTime() / 1000)
                    calendarSource.to = ~~(info.end.getTime() / 1000) - 1
                    filter.update();
                    //
                    $('.calendar-day.selected').removeClass('selected');

                    const elem = $('table.fc-scrollgrid-sync-table')
                        .find('[data-date="' + info.startStr + '"]')
                        .find('.calendar-day')
                        .addClass('selected')
                        .closest('a').focus()
                        .prevObject
                    const num = elem.data('real-count')
                },
                unselect: (info) => {
                    calendarSource.reset()
                    const elem = $('.fc-daygrid', container);
                    if (!elem.find(info.jsEvent.toElement).length) {
                        filter.update()
                    }

                    $('.calendar-day.selected').removeClass('selected')
                },
                unselectCancel: '[data-filter-by],.activities-list-wrapper,#MobilePlusButton',
                selectAllow: arg => true,//createDateId(arg.start) === createDateId(arg.end) - 1,
                dayCellContent: dayObj => {
                    const dateid = date =>  moment.tz(date, window.community.timeZone).format("YYYYMMDD")
                    const cdate = dateid(dayObj.date)
                    const events = calendar.getEvents().filter(event => dateid(event.start) === cdate)
                    const selected = calendar.currentData.dateSelection && dateid(calendar.currentData.dateSelection.range.start) === cdate
                        ? 'selected'
                        : ''
                    return {
                        html: `
                        <div class="calendar-day ${selected}" data-count="${events.length > 3 ? 4 : events.length}" data-real-count="${events.length}">
                            <div class="calendar-day-label">${dayObj.dayNumberText}</div>
                            <div class="calendar-day-events"></div>
                        </div>`
                    }
                },
                dayCellDidMount: dayObj => {
                    // make them tabbable.
                    const a = $(dayObj.el).removeAttr('aria-labelledby').find('a').attr('tabstop', "0").attr('href', '#')
                    const count = a.find('.calendar-day').data('real-count')
                    // if (count > 0) {
                    //     a.attr('aria-label', ariaMessage({day: dayObj.dayNumberText, count: count}))
                    // }
                    // select by enter/click
                    a.on('click', {date: dayObj.el.getAttribute('data-date')}, onclick)
                },
                ...window.calendarSettings || {},
            }
        )
        const onclick = e => {
            calendar.select(e.data.date)
            return false;
        }

        if (filter) {
            // Bind everything
            const sourceApi = calendar.addEventSource((info, success, fail) => {
                // Don't allow calendar selection to affect on the events list.
                const state = calendarSource.enabled
                calendarSource.enabled = false
                success(
                    filter
                        .getFiltered()
                        // jQuery list here.
                        .map(function () {
                            return {
                                // title: $(this).find('h3.activity-name').text(),
                                start: $(this).data('date') * 1000,
                                // end: $(this).data('ends') * 1000,
                            }
                        })
                        .get()
                )
                calendarSource.enabled = state
            })
            filter.addSource(calendarSource)
            filter.on('update', () => {
                sourceApi.refetch()
                calendar.render()
            })
            filter.on('clear', () => {
                sourceApi.refetch()
                calendar.render()
            })
            calendar.render();
            attachLabels();
        }
    }
}
